import React, { useReducer, useEffect, useState } from 'react';

import { validate } from '../../util/validators';
import Autosuggest from 'react-autosuggest';

import './Input.css';
import './AutoSuggestInput.css'
const inputReducer = (state, action) => {
  switch (action.type) {
    case 'CHANGE':
      return {
        ...state,
        value: action.val,
        isValid: validate(action.val, action.validators)
      };
    case 'TOUCH': {
      return {
        ...state,
        isTouched: true
      }
    }
    default:
      return state;
  }
};

const Input = props => {
  const [suggestions, setSuggestions] = useState([]);
  const [inputState, dispatch] = useReducer(inputReducer, 
    //initial state
    {
    value: props.initialValue || '',
    isTouched: false,
    isValid: props.initialValid || false
  });

  const { id, onInput, red } = props;
  const { value, isValid } = inputState;

  useEffect(() => {
    onInput(id, value, isValid )
  }, [id, value, isValid, onInput]);

  const changeHandler = (event, newVal) => {
   
    dispatch({
      type: 'CHANGE',
      val: props.element === 'smart_input' ? newVal : 
      event.target.value,
      validators: props.validators
    });
  };

  const touchHandler = () => {
    dispatch({
      type: 'TOUCH'
    });
  };

  // Teach Autosuggest how to calculate suggestions for any given input value.
  const getSuggestions = value => {
    const inputValue = value ? value.trim().toLowerCase(): "";
    const inputLength = inputValue.length;

  return inputLength === 0 ? [] : props.suggestionArray.filter(lang =>
      lang.name.toLowerCase().slice(0, inputLength) === inputValue
    ).slice(0,8);
  };

  const getSuggestionValue = suggestion => suggestion.name

  // Use your imagination to render suggestions.
  const renderSuggestion = suggestion => (
    <div>
        {suggestion.name}
    </div>
  );

  // Autosuggest will call this function every time you need to update suggestions.
  const onSuggestionsFetchRequested = (inputState) => {
      setSuggestions(getSuggestions(inputState.value))
  };

  // Autosuggest will call this function every time you need to clear suggestions.
  const onSuggestionsClearRequested = () => {
      setSuggestions([])
  };

  const onChange = (event, { newValue }) => {
    changeHandler(event, newValue);  
  };

  const inputProps = {
      "value" : inputState.value,
      "placeholder": props.placeholder,
      "onChange": onChange,
      "id": props.id,
      "type": props.type,
      "onBlur": touchHandler,
      
  };

  const element =
    props.element === 'input' ? (
      <input
        className={props.customClass}
        id={props.id}
        type={props.type}
        placeholder={props.placeholder}
        onChange={changeHandler}
        onBlur={touchHandler}
        value={inputState.value}
        ref={props.inputRef}
      />
    ) : (
      props.element === 'smart_input' ? (
      <Autosuggest
        suggestions={suggestions}
        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
        onSuggestionsClearRequested={onSuggestionsClearRequested}
        getSuggestionValue={getSuggestionValue}
        renderSuggestion={renderSuggestion}
        inputProps={inputProps}
      /> ) : (
      <textarea
        id={props.id}
        rows={props.rows || 3}
        onChange={changeHandler}
        onBlur={touchHandler}
        value={inputState.value}
      /> )
    );

  return (
    <React.Fragment>
      {props.simple ? element :
         <div
         className={`form-control ${!inputState.isValid && inputState.isTouched &&
           'form-control--invalid'}`}
          >
         <label htmlFor={props.id}>{red && <span className='red-label' >*</span>}   { props.label}</label>
         {element}
         {!inputState.isValid && inputState.isTouched && <p>{props.errorText}</p>}
       </div>   
      }
    </React.Fragment>
  );
};

export default Input;
